<template>
  <div class="modal-overlay" v-if="visible" @click.self="close">
    <div class="modal-box">
      <h3>{{ notice && notice.title }}</h3>
      <div class="notice-meta" v-if="notice">{{ notice.time }}</div>
      <p class="notice-body" v-if="notice" v-html="notice.content || notice.body"></p>
      <div class="modal-btns"><button class="confirm" @click="close">知道了</button></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoticeDetailModal',
  props: { visible: Boolean, notice: Object },
  methods: { close() { this.$emit('close') } }
}
</script>

<style lang="scss" scoped>
.notice-meta { font-size: 12px; color: var(--text-muted); margin-bottom: 12px; }
.notice-body { font-size: 14px; color: #666; line-height: 1.75; margin: 0; }
.modal-btns { display: flex; gap: 12px; margin-top: 16px; button { flex: 1; padding: 10px; border-radius: 6px; border: none; cursor: pointer; font-family: inherit; font-weight: 600; } .confirm { background: var(--red); color: #fff; } }
</style>
